import API from '../../utils/Api'
import i18n from '@/plugins/i18n'

const api = new API('demand-profiles')


const state = {
  list: [],
  loading: false,
  model: {
    name: "",
    type: "",
    demands: [],
    variability: 0,
    min: 0,
    max: 0,
    constant: 0
  }
}

const getters = {
  headers () {
    return [
      {
        text: i18n.t('demandProfiles.name'),
        align: 'center',
        value: 'name'
      },
      {
        text: i18n.t('demandProfiles.type'),
        align: 'center',
        value: 'typeName'
      },
      {
        text: i18n.t('general.actions'),
        align: 'center',
        sortable: false
      }
    ]
  },
  demandsHeaders () {
    return [
      {
        text: i18n.t('demandProfiles.weekNumber'),
        align: 'center',
        value: 'week',
        sortable: false
      },
      {
        text: i18n.t('demandProfiles.demands'),
        align: 'center',
        value: 'demands',
        sortable: false
      }
    ]
  },
  type () {
    return [
      {
        name: i18n.t('demandProfiles.typeList.custom'),
        number: 1
      },
      {
        name: i18n.t('demandProfiles.typeList.randomBetweenTwoValue'),
        number: 2
      },
      {
        name: i18n.t('demandProfiles.typeList.constant'),
        number: 3
      }
    ]
  }
}

const actions = {
  async getOne({ commit }, id) {
    try {
      commit('SET_loading', true)
      let res = await api.get(id)
      commit('SET_loading', false)
      return res.data
    } catch (error) {
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.getOneError') + error.message }, { root: true })
    }
  },
  async getAll({ commit }) {
    try {
      commit('SET_loading', true)
      let res = await api.getAll()
      commit('SET_list', res.data)
      commit('SET_loading', false)
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.getAllError') + error.message }, { root: true })
    }
  },
  async add({ commit }, data) {
    try {
      commit('SET_loading', true)
      let res = await api.post(data, '')
      commit('ADD_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.demandProfiles.add') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.addError') + error.message }, { root: true })
      return false
    }
  },
  async update({ commit }, params) {
    try {
      commit('SET_loading', true)
      let res = await api.put(params.id, params.data, "")
      commit('UPDATE_list', res.data)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.demandProfiles.update') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.updateError') + error.message }, { root: true })
      return false
    }
  },
  async delete({ commit }, params) {
    try {
      commit('SET_loading', true)
      await api.deleteMany(params)
      commit('DELETE_list', params)
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: true, message: i18n.t('notifications.demandProfiles.delete') }, { root: true })
      return true
    } catch (error) {
      commit('SET_loading', false)
      commit('interfaceSettings/SET_notification', { success: false, message: i18n.t('notifications.demandProfiles.deleteError') + error.message }, { root: true })
      return false
    }
  }
}

const mutations = {
  DELETE_list(state, toDelete) {
    for (let i = 0; i < toDelete.length; i++) {
      for (let index = 0; index < state.list.length; index++) {
        if (state.list[index]._id === toDelete[i]) {
          state.list.splice(index, 1)
          break
        }
      }
    }
    
  },
  UPDATE_list(state, val) {
    for (let index = 0; index < state.list.length; index++) {
      if (state.list[index]._id === val._id) {
        state.list.splice(index, 1, val)
        break
      }
    }
  },
  ADD_list(state, val) {
    state.list.push(val)
  },
  SET_list(state, val) {
    state.list = val
  },
  SET_loading(state, val) {
    state.loading = val
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}